import { Navigate, createFileRoute } from "@tanstack/react-router";

import { parseWorldView } from "../../../workspaces/worlds/search";


export const Route = createFileRoute(
  "/_console/p/$org/$project/build-worlds/assets/$worldId",
)({
  validateSearch: parseWorldView,
  component: WorldAssetRoute,
});

function WorldAssetRoute() {
  return <Navigate to="/p/$org/$project/simulate/assets/$worldId" params={Route.useParams()} search={Route.useSearch()} replace />;
}
